import { addMonth, getToday } from '@/utils/dateUtils';
import { GetTaskMessagesSearchRequest, TaskMessageStatusType, TaskMessageType } from 'ncp-api-supporter';
import { GridProp } from '@/pro/types';

const t = (text: string): string => window.$t(text);

export const INIT_PAGE = 1;
export const INIT_SIZE = 30;

export const gridProps = (): GridProp  => ({
  columns: [
    {
      header: t('CLAIM_MESSAGE_STATE'),
      name: 'taskMessageStatusType',
      align: 'center',
      width: 90,
      formatter: ({ value }): string =>
        value === 'PROCESSING' ? t('CLAIM_MESSAGE_PROCESSING') : t('CLAIM_MESSAGE_DONE'),
    },
    {
      header: t('COMMON_MALL'),
      name: 'mallName',
      align: 'center',
      width: 120,
      formatter: ({ value }): string => `${value}`,
    },

    {
      header: t('CLAIM_MESSAGE_REGISTRATION_DATE'),
      name: 'updateYmdt',
      align: 'center',
      width: 170,
      formatter: ({ value }): string => `${value}`,
    },
    {
      header: t('COMMON_ORDERNO'),
      name: 'orderNo',
      align: 'center',
      width: 170,
      formatter: ({ value }): string => `<a href="javascript:;">${value}</a>`,
    },
    {
      header: t('CLAIM_MESSAGE_TYPE'),
      name: 'taskMessageType',
      align: 'center',
      width: 90,
      formatter: ({ value }): string => {
        if (value === 'PRODUCT') {
          return t('CLAIM_MESSAGE_ORDER_PRODUCT');
        } else if (value === 'DELIVERY') {
          return t('CLAIM_MESSAGE_DELIVERY');
        } else if (value === 'CLAIM') {
          return t('CLAIM_MESSAGE_CANCEL_CHANGE_REFUND');
        } else if (value === 'REFUND') {
          return t('CLAIM_MESSAGE_REFUND');
        } else if (value === 'ETC') {
          return t('CLAIM_MESSAGE_ETC');
        }
      },
    },
    {
      header: t('CLAIM_MESSAGE_CONTENT'),
      name: 'content',
      align: 'left',
      formatter: ({ value }): string => `${value}`,
    },
    {
      header: t('CLAIM_MESSAGE_REGISTER_ADMIN_NAME'),
      name: 'registerAdminName',
      align: 'center',
      width: 90,
      formatter: ({ value }): string => `${value}`,
    },
    {
      header: t('CLAIM_MESSAGE_COMPLETED_ADMIN_NAME'),
      name: 'completedAdminName',
      align: 'center',
      width: 90,
      formatter: ({ value }): string => !value ? '-' : `${value}`,
    },
  ],
  options: {
    bodyHeight: 500,
    pageOptions: {
      perPage: INIT_SIZE,
      page: INIT_PAGE,
      totalCount: 0,
    }
  }
});

export const gridOption = {
  haveExcelDownBtn: false,
  haveConfigBtn: false,
  nonDataBodyHeight: 500,
  haveDataBodyHeight: 500,
};

export const taskMessagesGridDataInit = [{
  orderNo: '',
  registerAdminName: '',
  taskMessageStatusType: 'PROCESSING',
  taskMessageType: 'PAY',
  content: '',
  updateYmdt: '',
  completedAdminName: '',
  mallName: '',
}]

export const formDataInit: GetTaskMessagesSearchRequest['params'] = {
  dateType: null, // 타입에는 있지만 현 페이지에서는 사용이 안되서 null처리함
  startDateTime: addMonth(new Date(), -3),
  endDateTime: getToday(),
  taskMessageTypes: 'ALL' as TaskMessageType,
  taskMessageStatusType: 'ALL' as TaskMessageStatusType,
  page: INIT_PAGE,
  size: INIT_SIZE,
  keyword: '',
}

export const searchTypeSelectList = [
  {
    value: 'ORDER_NO',
    name: 'CLAIM_MESSAGE_ORDER_NO',
  },
  {
    value: 'REGISTER_ADMIN_NAME',
    name: 'CLAIM_MESSAGE_REGISTER_ADMIN_NAME',
  },
  {
    value: 'COMPLETED_ADMIN_NAME',
    name: 'CLAIM_MESSAGE_COMPLETED_ADMIN_NAME',
  },
];

export const periodOption = {
  name: 'startPeriod',
  periodTypes: ['td', '1w', '1m', '3m', '6m', '1y'],
  period: '3m',
};

export const taskMessageStatusTypeList = [
  {
    value: 'ALL',
    name: 'COMMON_ALL',
  },
  {
    value: 'PROCESSING',
    name: 'CLAIM_MESSAGE_PROCESSING',
  },
  {
    value: 'DONE',
    name: 'CLAIM_MESSAGE_DONE',
  },
];

export const taskMessageTypeOption = {
  name: 'taskMessageTypeOption',
  hasAll: true,
  noBrackets: true,
  data: [
    {
      id: 'taskMessageTypeOption_ALL',
      value: 'ALL',
      dispaly: 'COMMON_ALL_CHECK',
    },
    {
      id: 'taskMessageTypeOption_PRODUCT',
      value: 'PRODUCT',
      dispaly: 'CLAIM_MESSAGE_ORDER_PRODUCT',
    },
    {
      id: 'taskMessageTypeOption_DELIVERY',
      value: 'DELIVERY',
      dispaly: 'CLAIM_MESSAGE_DELIVERY',
    },
    {
      id: 'taskMessageTypeOption_CANCEL_CHANGE_REFUND',
      value: 'CLAIM',
      dispaly: 'CLAIM_MESSAGE_CANCEL_CHANGE_REFUND',
    },
    {
      id: 'taskMessageTypeOption_REFUND',
      value: 'REFUND',
      dispaly: 'CLAIM_MESSAGE_REFUND',
    },
    {
      id: 'taskMessageTypeOption_ETC',
      value: 'ETC',
      dispaly: 'CLAIM_MESSAGE_ETC',
    },
  ],
};